'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _typeToReducer;

var _typeToReducer2 = require('type-to-reducer');

var _typeToReducer3 = _interopRequireDefault(_typeToReducer2);

var _types = require('../UpdateLocation/types');

var _types2 = require('shared/redux/middlewares/geocoding/types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  loading: false
};

exports.default = (0, _typeToReducer3.default)((_typeToReducer = {}, (0, _defineProperty3.default)(_typeToReducer, _types.UPDATE_LOCATION, function (state) {
  return (0, _extends3.default)({}, state, {
    loading: true
  });
}), (0, _defineProperty3.default)(_typeToReducer, _types2.GEOCODE_LOCATIONS_FULFILLED, function (state) {
  return (0, _extends3.default)({}, state, {
    loading: false
  });
}), _typeToReducer), initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/JobNextSteps/reducer.js
// module id = 1210
// module chunks = 0